// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2XhzO","dragIcon":"SortableItem_dragIcon__xMELq","disabled":"SortableItem_disabled__1qB0V"};